const ordersReducer = (state = {
    loading:false,
    orders:[],totalRecords:0
}, action) => {
    switch (action.type) {
        case "FETCH_ORDERS":
            return { ...state ,loading:true,orders:[],totalRecords:0}
        case "RECEIVE_ORDERS":
            return {...state, orders:[...action.payload.orders],loading:false,totalRecords:action.payload.totalRecords}
        case "ERROR_ORDERS":
            return { ...state ,orders:[],loading:true,totalRecords:0}
        default:
            return { ...state }
    }
}

export default ordersReducer;